'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  // Options.jsx
  items_per_page: '/ sida',
  jump_to: 'Gå till',
  page: '',

  // Pagination.jsx
  prev_page: 'Föreg sida',
  next_page: 'Nästa sida',
  prev_5: 'Föreg 5 sidor',
  next_5: 'Nästa 5 sidor',
  prev_3: 'Föreg 3 sidor',
  next_3: 'Nästa 3 sidor'
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.8.5@rc-pagination/lib/locale/sv_SE.js
 ** module id = 735
 ** module chunks = 1
 **/